const getters = {
  goodsForeNo: state => state.print.goodsForeNo
}
export default getters
